import { PAGE_COUNTRY_MAP } from "@/src/constants/domain"

export const isGlobalDomain = (): boolean => {
    if (typeof window === 'undefined') return false
    const hostname = window?.location?.hostname?.toLowerCase()
    const origin = `https://${hostname.toLowerCase()}`
    const pageCountry = PAGE_COUNTRY_MAP[origin as keyof typeof PAGE_COUNTRY_MAP]
    return pageCountry == "global"
}

export default isGlobalDomain
